/**
 * DOMSHOT
 *
 * Convert the website into a form that will allow it to be rendered anywhere as a single
 * html file.  This means inlining all resources that are on the same domain.
 */

/**
 * expose run function
 */
export default {
  run(ticketId) {
    return _run(ticketId)
  }
}

var picnicAPIEndpoint = process.env.API_HOST

function _run() {
  // //console.log("DOMSHOT: Starting...");
  return new Promise(function(resolve, reject) {
    console.time('DOMSHOT: Sucessful!!  Completed in: ')
    return Promise.all([
      inlineAllStylesheets(),
      removeAllScripts(),
      convertImagesInInlineStyles(),
      convertCanvasToImage(),
      convertImagesToDataURI()
      // removePicnicUI(),
    ]).then(function() {
      uploadDomshot().then(function(url) {
        console.timeEnd('DOMSHOT: Sucessful!!  Completed in: ')
        // window.location.href = picnicAPIEndpoint + "/uploads/" + url;

        resolve(url)
      })
    })
  })
}

// A few regular expressions.
var isOnSameDomain = new RegExp('://' + location.host)
var isDataURI = /^(data:)([\w\/\+]+);(charset=[\w-]+|base64).*,(.*)/i
var isURLResourceInCSS = /url\s*\(\s*(?:'(\S*?)'|"(\S*?)"|((?:\\\s|\\\)|\\\"|\\\'|\S)*?))\s*\)/gi
var cssURLWrapper = /url\(("|')?|("|')?\)/gi

function escapeStringForRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
}

function createUrlRegex(url) {
  return new RegExp(
    'url\\(("|\')?' + escapeStringForRegExp(url) + '("|\')?\\)',
    'gi'
  )
}

function inlineAllStylesheets() {
  return new Promise(function(resolve, reject) {
    // //console.log('DOMSHOT: Inline all stylesheets');
    var cssText = [],
      i,
      remoteFiles = []

    // Convert the links to inline style elements.
    for (i = 0; i < document.styleSheets.length; i++) {
      remoteFiles.push(convertLinkToInlineStyle(document.styleSheets[i]))
    }

    Promise.all(remoteFiles)
      .then(function() {
        var i,
          stylesheetToSearch = []
        // All the stylesheets should now be style elements
        var styleElements = document.querySelectorAll('style')
        for (i = 0; i < styleElements.length; i++) {
          stylesheetToSearch.push(replaceAllUrlsInStylesheet(styleElements[i]))
        }
        Promise.all(stylesheetToSearch)
          .then(function() {
            resolve()
          })
          .catch(function() {
            console.error('DOMSHOT: ERROR 1')
          })
      })
      .catch(function() {
        console.error('DOMSHOT: ERROR 2')
      })
  })
}

function convertLinkToInlineStyle(stylesheet) {
  return new Promise(function(resolve, reject) {
    // //console.log("DOMSHOT: Inlining CSS File - " + stylesheet.href);
    if (
      stylesheet.ownerNode.tagName === 'LINK' &&
      isOnSameDomain.test(stylesheet.href)
    ) {
      fetchResource(stylesheet.href)
        .then(function(contentOfCSSFile) {
          // //console.log("DOMSHOT: Have CSS Content, replacing the link " + stylesheet.href);
          // First we have to convert any URLS relative to the css file to URLS relative
          // to the document.
          var imageUrls = contentOfCSSFile.match(isURLResourceInCSS)
          var alreadyConvertedURLs = {}
          var rawCSSURL, cssURL, fullCSSURL, i
          if (imageUrls) {
            for (i = 0; i < imageUrls.length; i++) {
              rawCSSURL = imageUrls[i].replace(cssURLWrapper, '')
              if (
                isDataURI.test(rawCSSURL) === false &&
                alreadyConvertedURLs[rawCSSURL] !== true
              ) {
                cssURL = new URL(rawCSSURL, stylesheet.href)
                fullCSSURL = cssURL.pathname + cssURL.search + cssURL.hash
                if (cssURL.origin !== window.location.origin) {
                  fullCSSURL = cssURL.origin + fullCSSURL
                }
                contentOfCSSFile = contentOfCSSFile.replace(
                  createUrlRegex(rawCSSURL),
                  'url("' + fullCSSURL + '")'
                )
                alreadyConvertedURLs[rawCSSURL] = true
              }
            }
          }
          //console.log(alreadyConvertedURLs);

          // Now write a the new style element to the document in place of the link element
          var newStyleElement = document.createElement('style')
          newStyleElement.textContent = contentOfCSSFile
          stylesheet.ownerNode.parentNode.replaceChild(
            newStyleElement,
            stylesheet.ownerNode
          )
          resolve()
        })
        .catch(function(error, response) {
          console.error('DOMSHOT: ERROR 3', error, response)
          resolve()
        })
    } else {
      resolve()
    }
  })
}

function replaceAllUrlsInStylesheet(stylesheet) {
  return new Promise(function(resolve, reject) {
    var urlsToReplace = [],
      i
    var imageUrls = stylesheet.textContent.match(isURLResourceInCSS)
    var styles = {
      css: stylesheet.textContent
    }
    if (imageUrls) {
      for (i = 0; i < imageUrls.length; i++) {
        urlsToReplace.push(replaceCSSURLWithDataURL(imageUrls[i], styles))
      }
    }

    return Promise.all(urlsToReplace)
      .then(function() {
        stylesheet.textContent = styles.css
        resolve()
      })
      .catch(function() {
        console.error('DOMSHOT: ERROR 4')
        resolve()
      })
  })
}

function replaceCSSURLWithDataURL(cssURL, styles) {
  return new Promise(function(resolve, reject) {
    var rawURL = cssURL.replace(cssURLWrapper, '')
    if (isDataURI.test(rawURL)) {
      resolve()
    } else {
      var fullURL = getAbsoluteUrl(rawURL)
      if (isOnSameDomain.test(fullURL)) {
        fetchResourceBase64(fullURL)
          .then(function(base64EncodedURL) {
            styles.css = styles.css.replace(rawURL, base64EncodedURL)
            resolve()
          })
          .catch(function(error) {
            console.error('ERROR GETTING: ' + fullURL, error)
            resolve()
          })
      } else {
        resolve()
      }
    }
  })
}

function removeAllScripts() {
  // //console.log('DOMSHOT: Remove all JS');

  return new Promise(function(resolve, reject) {
    var htmlEvents = [
      'onabort',
      'onautocomplete',
      'onautocompleteerror',
      'onbeforecopy',
      'onbeforecut',
      'onbeforepaste',
      'onblur',
      'oncancel',
      'oncanplay',
      'oncanplaythrough',
      'onchange',
      'onclick',
      'onclose',
      'oncontextmenu',
      'oncopy',
      'oncuechange',
      'oncut',
      'ondblclick',
      'ondrag',
      'ondragend',
      'ondragenter',
      'ondragleave',
      'ondragover',
      'ondragstart',
      'ondrop',
      'ondurationchange',
      'onemptied',
      'onended',
      'onerror',
      'onfocus',
      'oninput',
      'oninvalid',
      'onkeydown',
      'onkeypress',
      'onkeyup',
      'onload',
      'onloadeddata',
      'onloadedmetadata',
      'onloadstart',
      'onmousedown',
      'onmouseenter',
      'onmouseleave',
      'onmousemove',
      'onmouseout',
      'onmouseover',
      'onmouseup',
      'onmousewheel',
      'onpaste',
      'onpause',
      'onplay',
      'onplaying',
      'onprogress',
      'onratechange',
      'onreset',
      'onresize',
      'onscroll',
      'onsearch',
      'onseeked',
      'onseeking',
      'onselect',
      'onselectstart',
      'onshow',
      'onstalled',
      'onsubmit',
      'onsuspend',
      'ontimeupdate',
      'ontoggle',
      'onvolumechange',
      'onwaiting',
      'onwebkitfullscreenchange',
      'onwebkitfullscreenerror',
      'onwheel'
    ]
    var i, j, matchingElements

    // Remove the all scripts from the document
    for (i = document.scripts.length - 1; i >= 0; i--) {
      document.scripts[i].remove()
    }

    // Remove any js attached to html elements as events
    for (i = 0; i < htmlEvents.length; i++) {
      matchingElements = document.querySelectorAll('[' + htmlEvents[i] + ']')
      for (j = 0; j < matchingElements.length; j++) {
        matchingElements[htmlEvents[i]] = null
      }
    }

    // remove any javascript in hrefs
    matchingElements = document.querySelectorAll('[href^="javascript:"]')
    for (i = 0; i < matchingElements.length; i++) {
      matchingElements.href = ''
    }

    // remove any javascript in sources
    matchingElements = document.querySelectorAll('[src^="javascript:"]')
    for (i = 0; i < matchingElements.length; i++) {
      matchingElements.href = ''
    }

    // There may still be other places where javascript could exist like in CSS but that is probably good for now
    resolve()
  })
}

function convertImagesToDataURI(image) {
  // //console.log('DOMSHOT: Converting images to data urls');
  return new Promise(function(resolve, reject) {
    var imageConvertQueue = [],
      i

    for (i = 0; i < document.images.length; i++) {
      imageConvertQueue.push(convertImageToDataURI(document.images[i]))
    }

    return Promise.all(imageConvertQueue)
      .then(function() {
        resolve()
      })
      .catch(function() {
        console.error('DOMSHOT: ERROR 5')
        resolve()
      })
  })
}

function convertImageToDataURI(image) {
  return new Promise(function(resolve, reject) {
    if (isOnSameDomain.test(image.src) && isDataURI.test(image.src) === false) {
      fetchResourceBase64(image.src)
        .then(function(base64EncodedImage) {
          image.src = base64EncodedImage
          resolve()
        })
        .catch(function() {
          image.src = ''
          console.error('DOMSHOT: ERROR 6')
          resolve()
        })
    } else {
      resolve()
    }
  })
}

function convertImagesInInlineStyles() {
  // //console.log('DOMSHOT: Converting images found in style attributes');
  return new Promise(function(resolve, reject) {
    var elementsWithURLInStyle = document.querySelectorAll('[style*="url("]')

    var imageConvertQueue = [],
      i,
      j,
      imageUrls

    for (i = 0; i < elementsWithURLInStyle.length; i++) {
      imageUrls = elementsWithURLInStyle[i]
        .getAttribute('style')
        .match(isURLResourceInCSS)
      for (j = 0; j < imageUrls.length; j++) {
        imageConvertQueue.push(
          convertImageInStyle(imageUrls[j], elementsWithURLInStyle[i])
        )
      }
    }

    return Promise.all(imageConvertQueue)
      .then(function() {
        resolve()
      })
      .catch(function() {
        console.error('DOMSHOT: ERROR 7')
        resolve()
      })
  })
}

function convertImageInStyle(cssURL, element) {
  return new Promise(function(resolve, reject) {
    var rawURL = cssURL.replace(cssURLWrapper, '')
    if (isDataURI.test(rawURL)) {
      resolve()
    } else {
      var fullURL = getAbsoluteUrl(rawURL)
      if (isOnSameDomain.test(fullURL)) {
        fetchResourceBase64(fullURL)
          .then(function(base64EncodedURL) {
            element.setAttribute(
              'style',
              element.getAttribute('style').replace(rawURL, base64EncodedURL)
            )
            resolve()
          })
          .catch(function(error) {
            console.error('DOMSHOT: ERROR GETTING: ' + fullURL, error)
            resolve()
          })
      } else {
        resolve()
      }
    }
  })
}

function convertCanvasToImage() {
  //console.log('DOMSHOT: Converting canvas elements to images');
  return new Promise(function(resolve, reject) {
    var canvasElements = document.querySelectorAll('canvas')

    var i, j, replacementImage, currentCanvas, currentAttribute
    for (i = 0; i < canvasElements.length; i++) {
      currentCanvas = canvasElements[i]
      currentCanvas.getContext('webgl', { preserveDrawingBuffer: true })
      currentCanvas.getContext('webgl2', { preserveDrawingBuffer: true })

      replacementImage = new Image()
      replacementImage.src = currentCanvas.toDataURL('image/png')

      for (j = 0; j < currentCanvas.attributes.length; j++) {
        currentAttribute = currentCanvas.attributes[j]
        replacementImage.setAttribute(
          currentAttribute.name,
          currentAttribute.value
        )
      }

      currentCanvas.parentNode.replaceChild(replacementImage, currentCanvas)
    }

    resolve()
  })
}

function fetchResource(url) {
  return new Promise(function(resolve, reject) {
    var request = new XMLHttpRequest()
    request.open('GET', url, true)

    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        // Success!
        resolve(request.responseText)
      } else {
        // We reached our target server, but it returned an error
        reject(request.status, request)
      }
    }

    request.onerror = function() {
      // There was a connection error of some sort
      reject(request.status, request)
    }

    request.send()
  })
}

function fetchResourceBase64(url) {
  return new Promise(function(resolve, reject) {
    var request = new XMLHttpRequest()
    request.open('GET', url, true)
    request.responseType = 'arraybuffer'

    request.onload = function(e) {
      if (request.status >= 200 && request.status < 400) {
        // Success!
        var dataURL =
          'data:' +
          request.getResponseHeader('content-type') +
          ';base64,' +
          base64ArrayBuffer(e.currentTarget.response)
        resolve(dataURL)
      } else {
        // We reached our target server, but it returned an error
        console.error('Error (' + request.status + ') getting: ' + url)
        reject(request.status, request)
      }
    }

    request.onerror = function() {
      console.error('Error getting: ' + url)
      // There was a connection error of some sort
      reject(request.status, request)
    }

    request.send()
  })
}

var a = document.createElement('a')
function getAbsoluteUrl(url) {
  a.href = url
  return a.href
}

function base64ArrayBuffer(arrayBuffer) {
  var base64 = ''
  var encodings =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

  var bytes = new Uint8Array(arrayBuffer)
  var byteLength = bytes.byteLength
  var byteRemainder = byteLength % 3
  var mainLength = byteLength - byteRemainder

  var a, b, c, d
  var chunk

  // Main loop deals with bytes in chunks of 3
  for (var i = 0; i < mainLength; i = i + 3) {
    // Combine the three bytes into a single integer
    chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

    // Use bitmasks to extract 6-bit segments from the triplet
    a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
    b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
    c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
    d = chunk & 63 // 63       = 2^6 - 1

    // Convert the raw binary segments to the appropriate ASCII encoding
    base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
  }

  // Deal with the remaining bytes and padding
  if (byteRemainder == 1) {
    chunk = bytes[mainLength]

    a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

    // Set the 4 least significant bits to zero
    b = (chunk & 3) << 4 // 3   = 2^2 - 1

    base64 += encodings[a] + encodings[b] + '=='
  } else if (byteRemainder == 2) {
    chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

    a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
    b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

    // Set the 2 least significant bits to zero
    c = (chunk & 15) << 2 // 15    = 2^4 - 1

    base64 += encodings[a] + encodings[b] + encodings[c] + '='
  }

  return base64
}

function uploadDomshot() {
  // //console.log('DOMSHOT: Uploading');
  return new Promise(function(resolve, reject) {
    var data =
      new XMLSerializer().serializeToString(document.doctype) +
      document.documentElement.innerHTML
    var boundary =
      'PICNIC_DOMSHOT_UPLOADER' + Math.floor(Math.random() * Math.pow(10, 8))

    var body =
      '--' +
      boundary +
      '\r\n' +
      'Content-Disposition: form-data; name="snapshot"; ' +
      'filename="snapshot.html"\r\n' +
      'Content-type: text/html\r\n\r\n' +
      data +
      '\r\n' +
      '--' +
      boundary +
      '--'

    var xhr = new XMLHttpRequest()
    xhr.open('POST', process.env.VUE_APP_API_URL + '/snapshots', true)
    xhr.setRequestHeader(
      'Content-type',
      'multipart/form-data; boundary=' + boundary
    )
    xhr.onreadystatechange = function() {
      if (xhr.readyState == 4 && xhr.status == 201) {
        resolve(JSON.parse(xhr.response).id)
      }
    }
    xhr.onerror = function() {
      reject('ERROR: ' + xhr.statusText)
    }
    xhr.send(body)
  })
}

;(function() {
  var originalGetContextFunction = HTMLCanvasElement.prototype.getContext

  HTMLCanvasElement.prototype.getContext = function() {
    var type = arguments[0]
    var ctx = originalGetContextFunction.apply(this, arguments)
    if (ctx && !this.canvasType) {
      this.canvasType = type
    }
    return ctx
  }
})()
